export default __webpack_public_path__ + "static/googlePlay-8a5932c49bb1666021a95ea8903a5496.png";